export default __webpack_public_path__ + "static/media/project-pt.0c083805.png";